import { Button, Icon } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';
import ConnectedModuleCard from '../../../ConnectedModuleCard';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
};

const EmptyPropertyConditionModule = ({ title, description, actionUrl, actionText }: Props) => {
  return (
    <ConnectedModuleCard data-testid="EmptyPropertyConditionModule">
      <StyledEmptyStateContainer>
        <StyledIconContainer aria-hidden="true">
          <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconChecklistFilled />} />
        </StyledIconContainer>
        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>
        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>
        <Button asChild size="md" tone="brand" emphasis="filled">
          <a href={actionUrl}>{actionText}</a>
        </Button>
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyPropertyConditionModule;
